import { Box, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';

import './BindingsActions.css';
import { BindingsActionsProps } from './BindingsActions.types';

/**
 * Action buttons for binding operations (save/cancel)
 * Conditionally shows buttons based on current state and changes
 *
 */
export function BindingsActions({
  hasChanges,
  addingMode = false,
  onReset,
  onSave,
  resetting = false
}: BindingsActionsProps) {
  return (
    <Box className="save-actions-container">
      {(hasChanges || addingMode) && (
        <Button disabled={resetting} onClick={onReset} className="reset-button cancel-button">
          {resetting && <Refresh className="reset-spinner" />}
          Скасувати
        </Button>
      )}
      <Button disabled={!hasChanges} onClick={onSave} variant="contained" className="save-button">
        Зберегти зміни
      </Button>
    </Box>
  );
}
